import { Button } from "components/DesignSystem/Button/Button";
import ChatCard from "components/DesignSystem/ChatCard/ChatCard";
import {
  DefaultStreamChatGenerics,
  useChannelStateContext,
} from "stream-chat-react";
import { ReviewDocHeader } from "components/icons/ReviewDocHeader";
import { Files } from "components/icons/Files";
import { useAppSelector } from "hooks/useAppSelector";
import { ReviewParsed1120Fields } from "components/MessageBubble/ReviewParsed1120Fields";
import { useModal } from "hooks/useModal";

export const FilingDraftForReview = () => {
  const filingDraftReview = useAppSelector(
    (state) => state.filingDraftReview.reviewData
  );
  const draftReview = useModal();

  return (
    <>
      <ChatCard.Root>
        <ChatCard.Header>
          <div className="t-gap-1.5 t-flex t-items-center">
            <ReviewDocHeader />
            Review Draft
          </div>
        </ChatCard.Header>
        <ChatCard.Body>
          <div className="t-flex t-gap-3 t-items-center">
            <div className="t-h-6 t-w-6 t-rounded-full t-border t-border-solid t-border-neutral-0 t-flex t-items-center t-justify-center t-relative">
              <div className="t-text-text-30 -t-mt-0.5">
                <Files />
              </div>
              <div className="t-min-w-1.5 t-min-h-1.5 t-max-h-1.5 t-max-w-1.5 t-rounded-full t-bottom-0 t-right-0 t-absolute t-bg-orange" />
            </div>
            <div className="t-text-subtext-sm t-text-text-60">
              Review pending
            </div>
          </div>
          <Button size="small" customType="primary" onClick={draftReview.open}>
            Review
          </Button>
        </ChatCard.Body>
      </ChatCard.Root>
      {filingDraftReview && (
        <ReviewParsed1120Fields
          {...draftReview}
          isLoading={false}
          isSuccess={true}
          parsedData={filingDraftReview}
        />
      )}
    </>
  );
};
